import React, { useState } from 'react'
import { Row, Column } from '@components/Common'
import { WideProContainer } from '@components/ProfessionalDetail/style'
import ProfessionalSidebar from './ProfessionalSidebar'
import TabContent from '@components/ProfessionalDetail/TabContent'
import { Tab, Tabs } from '@components/Tabs/index'
import { generateRandomKey, tabsObject } from '@utils'

const ProfessionalMain = ({ tabsArr, tabsTitle, data, sidebar }) => {
  const [tab, setTab] = useState(0)
  return (
    <>
      {tabsArr?.length > 0 && (
        <Tabs
          pro
          tab={tab}
          setTab={setTab}
          margin="0"
          color="#f3f3f3"
          aria-label="Tabbed Content Navigation"
          border="1px solid #B4A06E"
          background="white"
          maxWidth
          width="100% !important"
          className="qtph-profprofile-tabs"
        >
          {tabsArr &&
            tabsArr.map((tabData, index) => (
              <Tab
                upperCase
                label={tabsObject[tabData]}
                key={`${tab}+${generateRandomKey()}`}
                activeTab={tab}
                index={index}
                border="2px solid #5f606254"
                borderRadius="0px"
                padding="11px 20px"
                fontSize="13px"
                tab={tab}
                setTab={setTab}
                pro
              />
            ))}
        </Tabs>
      )}
      <WideProContainer marginBottom={50}>
        <Row>
          <Column className="qtph-profprofile-body xl:mr-[50px] mb-15 lg:w-[67.5%] lg:ml-0 xl:w-2/3">
            <TabContent
              pro
              tab={tab}
              tabsArr={tabsArr}
              tabsTitle={tabsTitle}
              data={data}
            />
          </Column>
          <ProfessionalSidebar sidebar={sidebar} />
        </Row>
      </WideProContainer>
    </>
  )
}

export default ProfessionalMain
